import { combineReducers } from "redux";
import { lopReducer } from "./lopReducer";

export const danhMucReducerWrapper = combineReducers({
  
    lop: lopReducer,
  
})